module.exports = __webpack_public_path__ + "static/pic01-c3befeb87af5bf2b452d61e7256fdf93.jpg";